export const getCurrentPageName = state => state.tutorDashboard.currentPage;
export const getCurrentStudentId = state =>
  state.tutorDashboard.currentStudentId;
export const getStudentListLoadingStatus = state =>
  state.tutorDashboard.studentListLoadingStatus;
export const getStudentScoresLoadingStatus = state =>
  state.tutorDashboard.studentScoresLoadingStatus;
export const getMasteryDetailLoadingStatus = state =>
  state.tutorDashboard.masteryDetailLoadingStatus;
export const getMasteryLoadingStatus = state =>
  state.tutorDashboard.masteryLoadingStatus;
export const getAssessmentLoadingStatus = state =>
  state.tutorDashboard.assessmentLoadingStatus;
export const getAssessmentDetailLoadingStatus = state =>
  state.tutorDashboard.assessmentDetailLoadingStatus;
export const getFilterDataLoadingStatus = state =>
  state.tutorDashboard.filterDataLoadingStatus;
export const getTopicsData = state => state.tutorDashboard.masteryList;
export const getStudentList = state => state.tutorDashboard.studentList;
export const getSubtopicDetailData = state => state.tutorDashboard.subtopicData;
export const getAssessmentList = state => state.tutorDashboard.assessmentList;
export const getAssessmentDetail = state =>
  state.tutorDashboard.assessmentDetail;
export const getSchoolClasses = state => state.tutorDashboard.schoolClasses;
export const getSubjects = state => state.tutorDashboard.subjects;
export const getSemesters = state => state.tutorDashboard.semesters;
export const getSelectedClassIndex = state =>
  state.tutorDashboard.selectedClassIndex;
export const getSelectedSemesterIndex = state =>
  state.tutorDashboard.selectedSemesterIndex;
export const getSelectedSubjectIndex = state =>
  state.tutorDashboard.selectedSubjectIndex;
export const getSelectedClassId = state => {
  const { selectedClassIndex, schoolClasses } = state.tutorDashboard;
  const { id: selectedClassId = 0 } = schoolClasses[selectedClassIndex] || {};

  return selectedClassId;
};
export const getSelectedSemesterId = state => {
  const { selectedSemesterIndex, semesters } = state.tutorDashboard;
  const { id: selectedSemesterId = 0 } = semesters[selectedSemesterIndex] || {};

  return selectedSemesterId;
};
export const getSelectedSubjectId = state => {
  const { selectedSubjectIndex, subjects } = state.tutorDashboard;
  const { id: selectedSubjectId = 0 } = subjects[selectedSubjectIndex] || {};

  return selectedSubjectId;
};

export const getFilterConditions = state =>
  state.tutorDashboard.filterConditions;



// WEBPACK FOOTER //
// ./app/redux/tutorDashboard/states.js